/* eslint-disable import/prefer-default-export */
import { pushGAAction } from '../../../utils/gtm';

import { updateSessionStorage } from '../../../auth/persistance';

export const updateCurrentRole = (
  roles,
  costCenters,
  countryOrRoleid,
  component,
  done
) => {
  const newRole = roles.find(
    x => x.country === countryOrRoleid || x.value === countryOrRoleid
  );
  pushGAAction('ROLE', `${component}::${newRole.label}`);
  let costCenter = null;
  if (costCenters && costCenters.length) {
    const countryCostCenter = costCenters.find(x => x.id === newRole.country);
    costCenter = countryCostCenter
      ? {
          country: {
            title: 'Country',
            label: countryCostCenter.title,
            value: countryCostCenter.id
          },
          costcenter: {
            title: 'Company code',
            value: countryCostCenter.children[0].id,
            label: countryCostCenter.children[0].title
          }
        }
      : null;
  }
  updateSessionStorage(newRole.value, newRole.label);
  done(newRole, costCenter);
};



// WEBPACK FOOTER //
// ./src/components/common/Profile/utils.js